<template>
    <v-app-bar
        light
        clipped
        elevation="10"
        rounded="10"
        color="#6499faff"
        height="50px"
        fixed
        style="z-index: 100000;"
        dark
    >
        <v-app-bar-nav-icon class="included" @click.stop="setDrawer">
            <v-icon v-if="drawer">mdi-menu-open</v-icon>
            <v-icon v-else>mdi-menu</v-icon>
        </v-app-bar-nav-icon>
        <v-img
            src="@/assets/logo_kiddy_motion-01.png"
            contain
            class="topbar-logo"
            style="cursor: pointer;"
            @click="$router.push('/')"
        />
        <v-spacer />
        <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    color="orange"
                    v-bind="attrs"
                    v-on="on"
                >
                    mdi-alert-octagon-outline
                </v-icon>
            </template>
            <span>{{ $t('auth.logoutWarning', { time: tokenExpiration }) }}</span>
        </v-tooltip>
        <div class="session-timer mx-4 pl-5" :class="remainingMinutes < 5 ? 'session-timer-danger' : ''">
            {{ tokenExpiration }}
            <span>
                <v-btn x-small icon class="mb-1" @click="refreshToken">
                    <v-icon color="black">
                        mdi-refresh
                    </v-icon>
                </v-btn>
            </span>
        </div> -->
        <v-select
            v-model="$i18n.locale"
            :items="locales"
            item-text="label"
            item-value="code"
            hide-details
            dense
            solo-inverted
            style="max-width:80px;"
            class="mx-2"
        />
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon color="white">mdi-account-circle</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item class="py-0 my-0" link @click="logout">
                    <v-icon class="pr-2">mdi-logout</v-icon> <v-list-item-title class="custom-text">{{ $t('button.logout') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    import userService from '@/services/user'
    import moment from 'moment'
    export default {
        data() {
            return {
                active: false,
                icon: 'mdi-view-grid-outline',
                tokenExpiration: '',
                interval: null,
                remainingMinutes: null,
                locales: [
                    { code: 'el', label: 'ΕΛ' },
                    { code: 'en', label: 'EN' }
                ]
            }
        },
        computed: {
            refreshTokenExpiration() {
                return this.$store.getters.getRefreshTokenExpiration
            },
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            }
        },
        watch: {
            tokenExpiration() {
                this.remainingMinutes = moment(this.refreshTokenExpiration).subtract(30, 'minutes').diff(moment(), 'minutes')
            }
        },
        created() {
            this.setExpireTokenInterval()
        },
        methods: {
            setDrawer() {
                this.$store.dispatch('setDrawer', !this.drawer)
            },
            logout() {
                this.$store.dispatch('logout')
                this.$router.push(`/login`)
            },
            calculateTokenExpiration(newEpoch) {
                if (newEpoch) {
                    const expiration = moment(newEpoch)
                    const diff = expiration.diff(moment().utc().subtract(30, 'minutes'))
                    this.tokenExpiration = moment.utc(diff).format('mm:ss')
                }
            },
            refreshToken() {
                userService.refreshToken({
                    tokenValue: this.$store.getters.getRefreshToken
                }).then(resp => {
                    this.$store.dispatch('setRefreshToken', resp.data.refreshToken)
                    this.$store.dispatch('setRefreshTokenExpiration', resp.data.refreshTokenExpiration)
                    this.$store.dispatch('setToken', resp.data.token)
                })
            },
            setExpireTokenInterval() {
                if (this.interval) {
                    clearInterval(this.interval)
                }
                this.calculateTokenExpiration(this.refreshTokenExpiration)
                this.interval = setInterval(() => {
                    this.calculateTokenExpiration(this.refreshTokenExpiration)
                }, 1000)
            }
        }
    }
</script>

<style>

    .topbar-logo {
        max-width: 90px;
        height: 34px;
        margin-left: 4px;
    }

    .custom-text{
        font-size:small;
    }

    .session-timer{
        font-size: medium;
        font-weight: 700;
        width: 100px;
        height: 30px;
        border: 2px solid black;
    }

    .session-timer-danger{
        border-color: red !important;
        color: red !important;
    }

</style>
